import { MessagingState } from './types'

export const initialMessagingState: MessagingState = {
	connected: false
}
